<template>
	<div>
		<div v-if="$_hasAccessToFeature($FeatureId.POSITION_TEMPLATES_MANAGE, $PermissionAction.USE)">
			<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
				{{ snackbar.message }}
				<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
			</v-snackbar>

			<position-template :id="id" />
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PositionTemplate from '@/components/positionTemplate/PositionTemplate';

	export default {
		name: 'PagePositionTemplate',
		components: {
			PositionTemplate
		},
		props: {
			id: {
				required: true
			},
			previousAction: {
				type: String,
				required: false
			}
		},
		data() {
			return {
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				}
			};
		},
		created() {
			if (this.previousAction) {
				switch (this.previousAction) {
					case 'position_template_duplicated':
						this.showSnackbar('Duplicated Successfully');
						break;
					case 'position_template_created':
						this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} Created`);
						break;
					default:
						break;
				}
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			})
		},
		methods: {
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			}
		}
	};
</script>
